import {SET_POST_ACTION_KEY, SET_UNAVAILABLE_ITEMS, SET_DROPDOWN_CLOSED} from '../../actions/actionTypes';

export function storeCheckoutReducer(state, action) {
	state = state || {};
	switch (action.type) {
		case SET_POST_ACTION_KEY:
			return Object.assign({}, state, {postActionKey: action.postActionKey});
		case SET_UNAVAILABLE_ITEMS:
			return Object.assign({}, state, {unAvailableItems: action.items});
        case SET_DROPDOWN_CLOSED:
            return Object.assign({}, state, {isDropDownClosed: action.isDropDownClosed});
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/store/storeCheckoutReducer.js